import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ApplyCta from '../ApplyCta/ApplyCta';
import ProfileJobHeader from '../../JobDetail/ProfileJobHeader/ProfileJobHeader';
import './apply.css';
import { 
  contractIcon, 
  timerIcon, 
  shopIcon, 
  locationIcon, 
  starIcon, 
  usersIcon, 
  moneyIcon, 
  coinIcon, 
  userChefIcon, 
  utensilsIcon,
  scheduleIcon,
  applicantsIcon
} from '../../../../utils/icons';
import useFetchJobOffer from '../../../../hooks/jobs/useFetchJobOffer';
import Modal from 'react-modal';
import LocationMap from '../../../Shared/Map/LocationMap';

const Apply = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    jobPostId: Number(id),
    answers: {},
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorApplication, setErrorApplication] = useState('');
  const [errorMessage, setErrorMessage] = useState('')
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);

  const { jobOffer, loading, error } = useFetchJobOffer(id);

  useEffect(() => {
    if (isSubmitted || errorMessage) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [isSubmitted, errorMessage]);

  if (loading) {
    return (
      <div className="apply__loading-container fade-in">
        <div className="apply__loading-spinner"></div>
        <p className="apply__loading-text">Cargando...</p>
      </div>
    );
  }

  if (error) return <div>Errores</div>;

  const handleChange = ({ target: { name, value } }) =>
    setFormData(prev => ({ ...prev, [name]: value }));

  const handleQuestionChange = (questionId, answer) =>
    setFormData(prev => ({
      ...prev,
      answers: { ...prev.answers, [questionId]: answer },
    }));

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    const answersArray = Object.entries(formData.answers).map(([questionId, answer]) => ({
      questionId: parseInt(questionId), // Convert string to number
      answer,
    }));

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/application`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ jobPostId: formData.jobPostId, answers: answersArray }),
      });

      if (!response.ok) {
        const errorData = await response.json(); 
        setErrorMessage(errorData.message || 'Error al enviar en la aplicación.')
        return
      }

      setSuccessMessage('Aplicación enviada, gracias por tu tiempo.');
      setIsSubmitted(true);
    } catch (err) {
      setErrorMessage('Hubo un error en la aplicación');
    }
  };

 
  return (
    <div>
      {errorMessage  &&
       <div className="apply__success-application">
           <p className="error">{errorMessage}</p>
        </div>
      
      }
      {isSubmitted && (
        <div className="apply__success-application">
          <p>{successMessage}</p>
          <Link to="/panel-empleado/postulaciones">
            <button className="apply__application-redirect-button">Ver mis aplicaciones</button>
          </Link>
        </div>
      )}
      {jobOffer ? (
        <>
          <ProfileJobHeader data={jobOffer.headerData} />
          <div className="info-application-container" id="application-form">
            <div className="apply__offer-summary-container">
              <h2>Resumen oferta</h2>
              <div className="apply__job-offer-container">
                <div className="apply__job-offer-col-1">
                  <div className="apply__icon-info-container">
                    {shopIcon}
                    <div className="apply__label-info-container"> 
                      <p><strong>Empresa:</strong></p> 
                      <p>{jobOffer.headerData.name}</p>
                    </div>
                  </div>
                  
                  <div className="apply__icon-info-container">
                    {utensilsIcon}
                    <div className="apply__label-info-container"> 
                      <p><strong>Establecimiento:</strong></p>
                      <p>{jobOffer.headerData.companyType}</p>
                    </div>
                  </div>
                  
                  <div className="apply__icon-info-container">
                    {userChefIcon}
                    <div className="apply__label-info-container">
                      <p><strong>Posición:</strong></p>
                      <p>{jobOffer.headerData.position}</p>
                    </div>
                  </div>

                  <div className="apply__icon-info-container">
                    {starIcon}
                    <div className="apply__label-info-container">
                      <p><strong>Experiencia:</strong></p>
                      <p>{jobOffer.yearsOfExperience} years</p>
                    </div>
                  </div>
                </div>
                <div className="apply__job-offer-col-2">
                  <div className="apply__job-offer-location-contract">
                    <div className="apply__icon-info-container">
                      {moneyIcon}
                      <div className="apply__label-info-container">
                        <p><strong>Sueldo:</strong></p>
                        <p>{jobOffer.conditionsData.sueldo}</p>
                      </div>
                    </div>
                
                    <div className="apply__icon-info-container">
                      {contractIcon}
                      <div className="apply__label-info-container">
                        <p><strong>Contrato:</strong></p>
                        <p>{jobOffer.conditionsData.contrato}</p>
                      </div>
                    </div>

                    <div className="apply__icon-info-container">
                      {timerIcon}
                      <div className="apply__label-info-container">
                        <p><strong>Horario:</strong></p>
                        <p>{jobOffer.conditionsData.disponibilidad}</p> 
                      </div>
                    </div>
                    
                    <div className="apply__icon-info-container">
                      {scheduleIcon}
                      <div className="apply__label-info-container">
                        <p><strong>Fecha publicación:</strong></p>
                        <p>{jobOffer.creado}</p>
                      </div>
                    </div>
                 
                  </div>
                  <div className="apply__job-offer-salary-tips">
                    <div className="apply__icon-info-container">
                      {coinIcon}
                      <div className="apply__label-info-container">
                        <p><strong>Propinas:</strong></p> 
                        <p>{jobOffer.tips ? 'Yes' : 'No'}</p>
                      </div>
                    </div>
                    <div className="apply__icon-info-container">
                      {usersIcon}
                      <div className="apply__label-info-container">
                        <p><strong>Vacantes:</strong></p>
                        <p>{jobOffer.conditionsData.vacantes}</p>
                      </div>
                    </div>
                    <div className="apply__icon-info-container">
                      {applicantsIcon}
                      <div className="apply__label-info-container">
                        <p><strong>Aplicaciones:</strong></p>
                        <p>{jobOffer.aplicaciones}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>  
            </div>

            <div className='apply__locations-container'>
              <div className="apply__locations-box">
                  <h2>Ubicación</h2>
                  <div className="apply__location-item">
                      <div className="apply__address-container">
                        <p>{jobOffer.location?.[0] || jobOffer.informationData?.ubicación || 'No especificado'}</p> 
                      </div>
                  </div>
              </div>
              <LocationMap locations={jobOffer.location || []} type={"job"}/>
            </div>
        
            <form className="application-form" onSubmit={handleSubmit}>    
              <div className="apply__questions-general">
                <h2>Comencemos con tu postulación</h2>
                {jobOffer.questions?.map((question) => (
                  <div key={question.id} className="apply__question-container">
                    <label htmlFor={`question-${question.id}`}>{question.question}</label>
                    <textarea
                      className="apply__question-input"
                      id={`question-${question.id}`}
                      name={`question-${question.id}`}
                      value={formData.answers[question.id] || ''}
                      onChange={(e) => handleQuestionChange(question.id, e.target.value)}
                      rows="4"
                    />
                  </div>
                ))}
                <div className="apply__cta-container" id="apply-cta-section">
                  <h1>Estas a punto de postular</h1>
                  <button type="submit" className="submit-button" id="apply-button">
                    Postula ahora
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      ) : (
        <p>Loading job offer details...</p>
      )}
    </div>
  );
}

export default Apply;
